import React, {useState} from 'react'
import Tools from '../../components/Tools/Tools'
import {useSelector} from 'react-redux';
import ManageDisbursmentHeader from '../../components/Disbursment/ManageDisbursmentHeader'
import DepositoryList from '../../components/Depository/DepositoryList';

const DepositoryListPage = () => {
    const {authData} = useSelector((state) => state.authData);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dateColumn, setDateColumn] = useState('approval_date');
    const [searchStr, setToSearchStr] = useState('');


    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setDateColumn(dateColumn);
        setToSearchStr(searchStr);
    };
    
    return (
        <div>
            {/* <Tools/> */}
            <ManageDisbursmentHeader onDateChange={handleDateChange} startDate={fromDate} endDate={toDate} dateColumnType={dateColumn} type="Depository" />
            <div className='scheme p-2'>
                <DepositoryList fromDate={fromDate} toDate={toDate} dateColumn={dateColumn} searchStr={searchStr}/>
            </div>
        </div>
    )
}

export default DepositoryListPage
